<template>
  <div class="col-12 nopads">
    <span class="span-title">{{ $t('equipments.other_equipment') }}</span>
    <div class="row">
      <div class="col-3">
        {{ $t('equipments.equipment') }}
      </div>
      <div class="col-3 ">
        {{ $t('equipments.action') }}
      </div>
      <div class="col-3 ">
        {{ $t('equipments.condition') }}
      </div>
      <div
        class="col-3 pr-3 pl-0"
        :title="$t('orders.calculate_tooltip')"
      >
        {{ $t('equipments.material') }}
      </div>
    </div>
    <div
      v-for="(item, index) in linkedEquipments"
      :key="index"
    >
      <div class="row">
        <div class="col-sm-3 mt-1">
          <span class="mt-1">{{ getVelhoEquipmentTypeOid(item.oid) }}</span>
        </div>
        <div class="col-sm-3">
          <multiselect
            v-model="item.actions"
            class="multiselect_routa mt-1"
            :placeholder="$t('equipment_actions.select_action')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="false"
            :multiple="true"
            label="name"
            track-by="value"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="getEquipmentActions()"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
          <div class="col-sm-3">
              <span class="d-inline-block">
                <select
                    v-model="item.condition"
                    class="form-select form-select-sm sm-3 mt-1"
                >
                  <option :value="null">
                    {{ $t('orders.select_geometry_label') }}
                  </option>
                  <option
                      v-for="(propKey) in getConditions()"
                      :key="propKey.value"
                      :value="propKey.value"
                  >
                    {{ propKey.name }}
                  </option>
                </select>
              </span>
          </div>

          <div class="col-sm-3">
              <span class="d-inline-block">
                <select
                    :id="'layer-label' + item.name + index"
                    v-model="item.material"
                    class="form-select form-select-sm sm-3 mt-1"
                >
                  <option :value="null">
                    {{ $t('orders.select_geometry_label') }}
                  </option>
                  <option
                      v-for="(propKey) in getMaterials()"
                      :key="propKey.value"
                      :value="propKey.value"
                  >
                    {{ propKey.name }}
                  </option>
                </select>
              </span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";

export default {
    name: 'LinkedEquipment',
    mixins: [roadSignHelper, conversionModelHelper],
    props: {
        linkedEquipments: {
            type: Array,
            default: null
        }
    }
}
</script>
